import RichTextField from './RichTextField';
import scrubHtml from './utils/scrubHtml';

export default RichTextField;
export {
    RichTextField,
    scrubHtml
};
